/**
 * LAS MEDIDAS DE LOS DOS DÍAS DE FOTOS (informe del mensual, Enrique 28-10).
 *
 * En «Tus fotos y tus medidas» el cliente elige dos fotos de dos días, y debajo se comparan
 * las medidas de esos dos días: los dos valores y su diferencia.
 *
 * Las medidas de un día de fotos son las de la toma de ese mismo día; si ese día no se midió,
 * las de la toma más cercana a una semana como mucho (las fotos y las medidas del mensual se
 * suben casi siempre juntas, pero no siempre el mismo día). Más lejos no: serían de otro mes.
 *
 * Las tomas las manda el servidor en `informe.tomas_medidas` ({fecha, medidas}). Puro.
 */

export const DIAS_DE_MARGEN = 7;

/** Las diez, en el orden y con los nombres del diseño. */
export const MEDIDAS_DEL_INFORME = [
    ['cintura', 'Cintura'],
    ['cadera', 'Cadera'],
    ['hombros', 'Hombros'],
    ['mesoesternal', 'Mesoesternal'],
    ['brazo_d', 'Brazo dcho. relajado'],
    ['brazo_i', 'Brazo izq. relajado'],
    ['muslo_d', 'Muslo dcho.'],
    ['muslo_i', 'Muslo izq.'],
    ['gemelo_d', 'Gemelo dcho.'],
    ['gemelo_i', 'Gemelo izq.'],
];

const _dias = (a, b) => Math.abs((new Date(`${a}T12:00:00`) - new Date(`${b}T12:00:00`)) / 864e5);

/** La toma de ese día, o la más cercana a `DIAS_DE_MARGEN` días como mucho; null si no hay. */
export const tomaDelDia = (tomas, dia) => {
    if (!dia) return null;
    let mejor = null;
    for (const t of tomas || []) {
        if (!t?.fecha || !t.medidas) continue;
        const d = _dias(t.fecha, dia);
        if (d <= DIAS_DE_MARGEN && (!mejor || d < mejor.d)) mejor = { d, t };
    }
    return mejor ? mejor.t : null;
};

const _numero = (v) => {
    const n = Number(v);
    return v == null || v === '' || !Number.isFinite(n) || n <= 0 ? null : n;
};

/**
 * Las filas de la comparación: {clave, etiqueta, antes, despues, dif} (números o null).
 * `hay` false si ninguno de los dos días tiene medidas.
 */
export const medidasEntre = (tomas, diaAntes, diaDespues) => {
    const a = tomaDelDia(tomas, diaAntes);
    const b = tomaDelDia(tomas, diaDespues);
    const filas = MEDIDAS_DEL_INFORME.map(([clave, etiqueta]) => {
        const antes = _numero(a?.medidas?.[clave]);
        const despues = _numero(b?.medidas?.[clave]);
        return { clave, etiqueta, antes, despues,
            dif: antes != null && despues != null ? Math.round((despues - antes) * 10) / 10 : null };
    });
    return { hay: !!(a || b), tomaAntes: a, tomaDespues: b, filas };
};
